'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var $toggleSearch = $('[data-toggle-search]');
    $toggleSearch.on('click', function (event) {
        event.preventDefault();
        // let $click = $(event.currentTarget);
        // $click.hide();
        var searchButton = $('[data-toggle-search]');
        var searchForm = $('[data-search-form]');
        if ($('[data-search-form]').hasClass('is-active')) {
            searchButton.removeClass('is-active');
            searchForm.removeClass('is-active');
        } else {
            searchButton.addClass('is-active');
            searchForm.addClass('is-active').find('input').first().focus();
        }
    });

    var activeClass = 'is-active';

    var collapsible = function collapsible() {
        $('.collapsible-navigation button, .shipping-info a, .submenu-toggle a').on('click', function (event) {
            event.preventDefault();
            var $clicked = $(event.currentTarget);
            var expanded = $clicked.attr('aria-expanded') === 'true';
            $clicked.attr('aria-expanded', !expanded);
            var target = $clicked.data('collapsible');
            $clicked.parents('.collapsible-navigation, .shipping-info, .submenu-toggle').toggleClass(activeClass);
            $('' + target).toggleClass(activeClass);
        });
    };
    collapsible();

    var closecollapsible = function closecollapsible() {
        $('.collapsible-navigation a.navstyle').on('click', function (event) {
            $('.collapsible-navigation button').trigger('click');
        });
    };
    closecollapsible();

    var toggleArticles = function toggleArticles() {
        $('.article-list-section .article-toggle-button ').on('click', function (event) {
            event.preventDefault();
            var $clicked = $(event.currentTarget);
            var $clickedParent = $clicked.parent('has-mask');
            var expanded = $clickedParent.attr('aria-expanded') === 'true';
            $('.has-mask').attr('aria-expanded', !expanded).toggleClass(activeClass);
        });
    };
    toggleArticles();

    var visible = function visible() {
        $('[data-filter] a').on('click', function (event) {
            event.preventDefault();
            var $clicked = $(event.currentTarget);
            var target = $clicked.attr('href');
            var $header = $('.sticky-header');
            if (target === '#') {
                $('.single-collection').show();

                return;
            }
            $('.single-collection').hide();
            $(target).show();
            $('html, body').animate({

                scrollTop: $(target).offset().top - $header.height() - 50
            }, 100);
        });
    };
    visible();

    var collectionFilter = function collectionFilter() {
        var $filterLink = $('[data-filter] a');
        var $firstFilter = $filterLink.first();
        $firstFilter.addClass(activeClass);
        $filterLink.on('click', function (event) {
            event.preventDefault();
            var $clicked = $(event.currentTarget);
            $filterLink.removeClass(activeClass);
            $clicked.addClass(activeClass);
        });
    };
    collectionFilter();

    var videoInit = function videoInit() {
        var $videoPlayer = $('#video-page-player');
        var videoLink = $('.responsive-video').data('video-id');
        var $category = $('[data-category="video-group1"]');
        var firstCategoryVideo = $category.find('.video-block a').eq(0).data('video-id');
        var secondCategoryVideo = $category.find('.video-block a').eq(1).data('video-id');
        var $nowPlaying = $('.current-video-block img');
        var $upNext = $('.next-video-block img');
        if ($('#video-page-player').length > 0 && videoLink !== '') {
            $videoPlayer.attr('src', 'https://www.youtube.com/embed/' + firstCategoryVideo);
            $nowPlaying.attr('src', '//i.ytimg.com/vi/' + firstCategoryVideo + '/default.jpg');
            $nowPlaying.attr('data-src', '//i.ytimg.com/vi/' + firstCategoryVideo + '/maxresdefault.jpg');
            $upNext.attr('src', '//i.ytimg.com/vi/' + secondCategoryVideo + '/default.jpg');
            $upNext.attr('data-src', '//i.ytimg.com/vi/' + secondCategoryVideo + '/maxresdefault.jpg');
        }
    };
    videoInit();

    var videoSelect = function videoSelect() {
        $('.video-block a').on('click', function (event) {
            event.preventDefault();
            var $current = $(event.currentTarget);
            var currentLink = $current.data('video-id');
            var $videoPlayer = $('#video-page-player');
            var $nowPlaying = $('.current-video-block img');
            var nextVideo = $current.parent().next().children('a').data('video-id');
            var $upNext = $('.next-video-block img');
            if (currentLink !== '') {
                $videoPlayer.attr('src', 'https://www.youtube.com/embed/' + currentLink);
                $nowPlaying.attr('src', '//i.ytimg.com/vi/' + currentLink + '/maxresdefault.jpg');
                if (nextVideo) {
                    $upNext.attr('src', '//i.ytimg.com/vi/' + nextVideo + '/maxresdefault.jpg');
                } else {
                    $upNext.attr('src', '');
                }
            }
        });
    };
    videoSelect();

    var buddyBundler = function buddyBundler() {
        var $radioOption = $('.bundle-selector');
        $radioOption.on('change', function (evt) {
            var $leftImage = $('.sliding-images-container-left').find('.selected-left');
            var $rightImage = $('.sliding-images-container-right').find('.selected-right');
            if ($leftImage.length > 0 || $rightImage.length > 0) {
                $leftImage.removeClass('selected-left');
            }
            if ($rightImage.length > 0) {
                $rightImage.removeClass('selected-right');
            }

            var firstSelection = $('.bundle-1').find(':checked');
            var index1 = firstSelection.data('index');
            var secondSelection = $('.bundle-2').find(':checked');
            var index2 = secondSelection.data('index');
            var $firstImage = $('.sliding-images-container-left [data-selected-image="' + index1 + '"]');
            var $secondImage = $('.sliding-images-container-right [data-selected-image="' + index2 + '"]');

            var selector1 = firstSelection.attr('value');
            var selector2 = secondSelection.attr('value');
            var selectedName1 = $('.bundle-1 > p');
            var selectedName2 = $('.bundle-2 > p');
            if (index1) {
                selectedName1.text(selector1).removeClass('text--disabled');
                $firstImage.addClass('selected-left');
            }
            if (index2) {
                selectedName2.text(selector2).removeClass('text--disabled');
                $secondImage.addClass('selected-right');
            }
            if (!index1 || !index2) return;
            var total = '' + index1 + index2;
            var url = '';
            switch (total) {
                case '11':
                    url = '/products/2-0-yellow-buddy-deal';
                    break;
                case '12':
                case '21':
                    url = '/products/double-flybuy';
                    break;
                case '13':
                case '31':
                    url = '/products/2-0-garden-flybuy-combo-buddy-deal';
                    break;
                case '14':
                case '41':
                    url = '/products/passion-assassin-yellow-combo-buddy-deal';
                    break;
                case '22':
                    url = '/products/camofly-2-0-limited-edition-2-pack-with-free-standard-shipping';
                    break;
                case '23':
                case '32':
                    url = '/products/camofly-garden-2-0-flybuy-combo-buddy-deal';
                    break;
                case '24':
                case '42':
                    url = '/products/passion-assassin-camo-combo';
                    break;
                case '33':
                    url = '/products/lawn-garden-2-0-buddy-deal';
                    break;
                case '34':
                case '43':
                    url = '/products/passion-assassin-garden-camo';
                    break;
                case '44':
                    url = '/products/passion-assassin-buddy-deal';
                    break;
            }
            $('[data-buddy-btn]').attr('href', url).removeClass('button--disabled');
        });
    };
    buddyBundler();

    var buddyBundler30 = function buddyBundler30() {
        var $radioOption = $('.bundle-selector30');
        $radioOption.on('change', function (evt) {
            var $leftImage = $('.sliding-images-container-left').find('.selected-left');
            var $rightImage = $('.sliding-images-container-right').find('.selected-right');
            if ($leftImage.length > 0 || $rightImage.length > 0) {
                $leftImage.removeClass('selected-left');
            }
            if ($rightImage.length > 0) {
                $rightImage.removeClass('selected-right');
            }

            var firstSelection = $('.bundle-1').find(':checked');
            var index1 = firstSelection.data('index');
            var secondSelection = $('.bundle-2').find(':checked');
            var index2 = secondSelection.data('index');
            var $firstImage = $('.sliding-images-container-left [data-selected-image="' + index1 + '"]');
            var $secondImage = $('.sliding-images-container-right [data-selected-image="' + index2 + '"]');

            var selector1 = firstSelection.attr('value');
            var selector2 = secondSelection.attr('value');
            var selectedName1 = $('.bundle-1 > p');
            var selectedName2 = $('.bundle-2 > p');
            if (index1) {
                selectedName1.text(selector1).removeClass('text--disabled');
                $firstImage.addClass('selected-left');
            }
            if (index2) {
                selectedName2.text(selector2).removeClass('text--disabled');
                $secondImage.addClass('selected-right');
            }
            if (!index1 || !index2) return;
            var total = '' + index1 + index2;
            var url = '';
            switch (total) {
                case '11':
                    url = '/products/black-fly-3-0-buddy-deal';
                    break;
                case '12':
                case '21':
                    url = '/products/black-crush-combo-3-0-buddy-deal';
                    break;
                case '13':
                case '31':
                    url = '/products/black-fly-classic-yellow-3-0-buddy-deal';
                    break;
                case '14':
                case '41':
                    url = '/products/limited-edition-clear-em-out-black-fly-3-0-buddy-deal-2-guns';
                    break;
                case '22':
                    url = '/products/orange-crush-3-0-buddy-deal';
                    break;
                case '23':
                case '32':
                    url = '/products/orange-crush-classic-yellow-3-0-buddy-deal';
                    break;
                case '24':
                case '42':
                    url = '/products/limited-edition-clear-em-out-orange-crush-3-0-buddy-deal-2-guns';
                    break;
                case '33':
                    url = '/products/classic-yellow-3-0-buddy-deal';
                    break;
                case '34':
                case '43':
                    url = '/products/limited-edition-clear-em-out-classic-yellow-3-0-buddy-deal-2-guns';
                    break;
                case '44':
                    url = '/products/limited-edition-bug-a-salt-3-0-clear-em-out-1';
                    break;
            }
            $('[data-buddy-btn]').attr('href', url).removeClass('button--disabled');
        });
    };
    buddyBundler30();

    var buddyBundler2beam = function buddyBundler2beam() {
        var $radioOption = $('.bundle-selector2beam');
        $radioOption.on('change', function (evt) {
            var $leftImage = $('.sliding-images-container-left').find('.selected-left');
            var $rightImage = $('.sliding-images-container-right').find('.selected-right');
            if ($leftImage.length > 0 || $rightImage.length > 0) {
                $leftImage.removeClass('selected-left');
            }
            if ($rightImage.length > 0) {
                $rightImage.removeClass('selected-right');
            }

            var firstSelection = $('.bundle-1').find(':checked');
            var index1 = firstSelection.data('index');
            var secondSelection = $('.bundle-2').find(':checked');
            var index2 = secondSelection.data('index');
            var $firstImage = $('.sliding-images-container-left [data-selected-image="' + index1 + '"]');
            var $secondImage = $('.sliding-images-container-right [data-selected-image="' + index2 + '"]');

            var selector1 = firstSelection.attr('value');
            var selector2 = secondSelection.attr('value');
            var selectedName1 = $('.bundle-1 > p');
            var selectedName2 = $('.bundle-2 > p');
            if (index1) {
                selectedName1.text(selector1).removeClass('text--disabled');
                $firstImage.addClass('selected-left');
            }
            if (index2) {
                selectedName2.text(selector2).removeClass('text--disabled');
                $secondImage.addClass('selected-right');
            }
            if (!index1 || !index2) return;
            var total = '' + index1 + index2;
            var url = '';
            switch (total) {
                case '11':
                    url = '/products/yellow-2-0-buddy-deal-bug-beam-combo';
                    break;
                case '12':
                case '21':
                    url = '/products/yellow-2-0-camofly-2-0-buddy-deal-bug-beam-combo';
                    break;
                case '13':
                case '31':
                    url = '/products/yellow-2-0-passion-assassin-2-0-buddy-deal-bug-beam-combo';
                    break;
                case '14':
                case '41':
                    url = '/products/yellow-2-0-lawn-garden-2-0-buddy-deal-bug-beam-combo';
                    break;
                case '22':
                    url = '/products/camofly-2-0-buddy-deal-bug-beam-combo';
                    break;
                case '23':
                case '32':
                    url = '/products/camofly-2-0-passion-assassin-2-0-buddy-deal-bug-beam-combo';
                    break;
                case '24':
                case '42':
                    url = '/products/camofly-2-0-lawn-garden-2-0-buddy-deal-bug-beam-combo';
                    break;
                case '33':
                    url = '/products/passion-assassin-2-0-buddy-deal-bug-beam-combo';
                    break;
                case '34':
                case '43':
                    url = '/products/lawn-garden-2-0-passion-assassin-2-0-buddy-deal-bug-beam-combo';
                    break;
                case '44':
                    url = '/products/lawn-garden-2-0-buddy-deal-bug-beam-combo';
                    break;
            }
            $('[data-buddy-btn]').attr('href', url).removeClass('button--disabled');
        });
    };
    buddyBundler2beam();

    var buddyBundler30beam = function buddyBundler30beam() {
        var $radioOption = $('.bundle-selector30beam');
        $radioOption.on('change', function (evt) {
            var $leftImage = $('.sliding-images-container-left').find('.selected-left');
            var $rightImage = $('.sliding-images-container-right').find('.selected-right');
            if ($leftImage.length > 0 || $rightImage.length > 0) {
                $leftImage.removeClass('selected-left');
            }
            if ($rightImage.length > 0) {
                $rightImage.removeClass('selected-right');
            }

            var firstSelection = $('.bundle-1').find(':checked');
            var index1 = firstSelection.data('index');
            var secondSelection = $('.bundle-2').find(':checked');
            var index2 = secondSelection.data('index');
            var $firstImage = $('.sliding-images-container-left [data-selected-image="' + index1 + '"]');
            var $secondImage = $('.sliding-images-container-right [data-selected-image="' + index2 + '"]');

            var selector1 = firstSelection.attr('value');
            var selector2 = secondSelection.attr('value');
            var selectedName1 = $('.bundle-1 > p');
            var selectedName2 = $('.bundle-2 > p');
            if (index1) {
                selectedName1.text(selector1).removeClass('text--disabled');
                $firstImage.addClass('selected-left');
            }
            if (index2) {
                selectedName2.text(selector2).removeClass('text--disabled');
                $secondImage.addClass('selected-right');
            }
            if (!index1 || !index2) return;
            var total = '' + index1 + index2;
            var url = '';
            switch (total) {
                case '11':
                    url = '/products/black-fly-3-0-buddy-deal-bug-beam-combo';
                    break;
                case '12':
                case '21':
                    url = '/products/orange-crush-3-0-black-fly-3-0-buddy-deal-bug-beam-combo';
                    break;
                case '13':
                case '31':
                    url = '/products/yellow-3-0-black-fly-3-0-buddy-deal-bug-beam-combo';
                    break;
                case '14':
                case '41':
                    url = '/products/limited-edition-clear-em-out-black-fly-3-0-buddy-deal-bug-beam-combo-2-guns-2-beams';
                    break;
                case '22':
                    url = '/products/orange-crush-3-0-buddy-deal-bug-beam-combo';
                    break;
                case '23':
                case '32':
                    url = '/products/yellow-3-0-orange-crush-buddy-deal-bug-beam-combo';
                    break;
                case '24':
                case '42':
                    url = '/products/limited-edition-clear-em-out-oragne-crush-buddy-deal-bug-beam-combo-2-guns-2-beams';
                    break;
                case '33':
                    url = '/products/yellow-3-0-buddy-deal-bug-beam-combo';
                    break;
                case '34':
                case '43':
                    url = '/products/limited-edition-clear-em-out-classic-yellow-3-0-buddy-deal-bug-beam-combo-2-gun-2-beams';
                    break;
                case '44':
                    url = '/products/limited-edition-bug-a-salt-3-0-clear-em-out-buddy-deal-bug-beam-combo-2-guns-2-beams';
                    break;
            }
            $('[data-buddy-btn]').attr('href', url).removeClass('button--disabled');
        });
    };
    buddyBundler30beam();
};